import React, { useContext } from "react";
import { StoreContext } from "../context/StoreContext";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { usePromotionsStyles } from "../styles/PromotionsFormStyles";
// prettier-ignore
import { Paper, Grid, TextField, FormControl, InputAdornment, Switch, Button, FormControlLabel } from "@mui/material";
// prettier-ignore
import { Snackbar } from "@mui/material";
import PropTypes from "prop-types";
import * as queries from "../graphql/queries";
import CompaniesTable from "../components/CompaniesTable";
import { FormHeading } from "../utils/CommonComonents/FormHeading";
import { execRead } from "../modules/DBService";
import { subscriptionLevelConst } from "../utils/Constants";
import { Outlet, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { onSaveFunctionAtom } from "../atoms/atoms";
function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};
function CompanyForm(props) {
    const navigate = useNavigate();

    //select
    const [values, setValues] = React.useState({
        active: true,
        searchTerms: ""
    });
    //active pending switch
    const [active, setActive] = React.useState(true);
    const [selected, setSelected] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [filteredRows, setFilteredRows] = React.useState([]);

    const [nameFilter, setNameFilter] = React.useState("");
    const [deleteDialog, setDeleteDialog] = React.useState(false);
    const [subLevel, setSubLevel] = React.useState([]);
    // snackbar
    const [msgOpen, setMsgOpen] = React.useState(false);
    const [snackMsg, setSnackMsg] = React.useState();
    const [, setOnCompanySaveFunction] = useAtom(onSaveFunctionAtom);

    let filter = {
        active: {
            eq: true
        }
    };

    React.useEffect(() => {
        fetchCompanyList();
    }, []);

    async function fetchCompanyList() {
        let listCompanyData = await execRead({
            opname: "listCompanys",
            op: queries.listCompanys,
            filter: filter
        });
        let data = listCompanyData.items.map((item) =>
            item.subscriptionLevel
                ? item
                : { ...item, subscriptionLevel: "None" }
        );
        data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setRows(data);
        console.log(data);
        console.log(subscriptionLevelConst);
    }

    async function filterCompanyList(filter) {
        let listCompanyData = await execRead({
            opname: "listCompanys",
            op: queries.listCompanys,
            filter: filter ? filter : ""
        });
        listCompanyData.items.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setRows(listCompanyData.items);
        return listCompanyData.items;
    }

    function handleMsgClose(event, reason) {
        setMsgOpen(false);
    }

    const handleCompanyChange = async (event) => {
        let value = nameFilter.toLowerCase();
        filter = {
            ...filter,
            active: {
                eq: active
            }
        };
        if (event.target.type != "checkbox") {
            setNameFilter(event.target.value);
            value = event.target.value.toLowerCase();
        } else {
            filter = {
                ...filter,
                active: {
                    eq: event.target.checked
                }
            };
        }
        let listCompanyData = await filterCompanyList(filter);

        let filteredData = listCompanyData.filter((item) => {
            return (
                item.name.toLowerCase().match(new RegExp(value, "g")) ||
                (item.subscriptionLevel &&
                    item.subscriptionLevel
                        .toLowerCase()
                        .split("_")
                        .join(" ")
                        .match(new RegExp(value, "g")))
            );
        });

        filteredData.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setFilteredRows(filteredData);
    };

    const { actions } = useContext(StoreContext);
    const classes = usePromotionsStyles();
    function handleCompanyAddClick() {
        setOnCompanySaveFunction(() => fetchCompanyList());
        actions.setMode("Add");
        navigate("create");
    }

    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                open={msgOpen}
                autoHideDuration={3000}
                onClose={handleMsgClose}
                ContentProps={{
                    "aria-describedby": "message-id"
                }}
                message={<span id="message-id">{snackMsg}</span>}
            />
            <FormHeading title={"Companies"} classes={classes} />
            <Paper
                style={{ minWidth: "300px", overflowX: "auto" }}
                rounded="true"
                className={classes.root}
            >
                <Grid container spacing={10}>
                    <Grid item xs={4}>
                        <TextField
                            id="search"
                            name="searchTerms"
                            label="Filter by name or subscription level"
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            value={nameFilter}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            onChange={handleCompanyChange}
                        />
                    </Grid>

                    <Grid item xs={3} className={classes.flexDisplay}>
                        <FormControlLabel
                            margin="normal"
                            control={
                                <Switch
                                    checked={active}
                                    onChange={(event) => {
                                        setActive(event.target.checked);
                                        handleCompanyChange(event);
                                    }}
                                    value="active"
                                    color="primary"
                                    name="active"
                                    inputProps={{
                                        "aria-label": "primary checkbox"
                                    }}
                                />
                            }
                            label="Active"
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    alignItems="center"
                    className={classes.marginBottom}
                >
                    <Grid item xs={4}></Grid>
                    <Grid item xs={6}></Grid>
                    <Grid item xs={2} alignItems="flex-end">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleCompanyAddClick}
                        >
                            <AddIcon className={classes.leftIcon} />
                            &nbsp;Add
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={10}>
                    <Grid item xs={12}>
                        <div className={classes.root}>
                            <Grid
                                item
                                xs={2}
                                className={classes.disablepadding}
                            >
                                <FormControl
                                    variant="outlined"
                                    className={classes.fullWidth}
                                ></FormControl>
                            </Grid>
                            <CompaniesTable
                                companiList={
                                    nameFilter.trim() === ""
                                        ? rows
                                        : filteredRows
                                }
                                editCompanyClick={() => navigate("edit")}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Paper>
            <Outlet></Outlet>
        </>
    );
}

export default CompanyForm;
